import React, { useState, useEffect } from "react";
import { FaClock, FaMapMarkerAlt, FaHourglassStart } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import PaymentPopup from "./PaymentPopup"; // Import the popup component

const ConfirmetPage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState("");
  useEffect(() => {
    fetchEvents();
  }, []);
  const fetchEvents = async () => {
    try {
      const response = await axios.get("/events/get_confirmed", {
        params: {
          user_type: sessionStorage.getItem("profession_id"),
          lom_id: sessionStorage.getItem("lom"),
        },
      });
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);

    const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
    const day = date.getDate().toString().padStart(2, "0");
    const monthName = date.toLocaleDateString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${dayName}, ${day} ${monthName} ${year}`;
  }
  const handlePaymentClick = (id) => {
    setEventId(id);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setEventId("");
    setShowPopup(false);
  };

  const handlePaymentSubmit = async (amount, event_id) => {
    try {
      const response = await axios.get("/events/make_payment", {
        params: {
          event_id: event_id,
          amount: amount,
        },
      });

      if (response.data.success) {
        toast("Payment updated!");
        fetchEvents();
      }
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
    console.log("Payment submitted:", amount);
    // Add logic to process the payment
    setShowPopup(false);
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Confirmed Zone trainer</h2>
      <ToastContainer />
      {events
        ? events.map((event) => (
            <div className="mt-16 md:mt-4">
              <div className="grid grid-cols-1 md:grid-cols-6 gap-4 p-4 border rounded-lg hover:bg-[#f8f8f8] mb-2">
                {/* Date Section */}
                <div className="font-semibold text-lg md:border-r pr-4 mb-4 md:mb-0 text-center md:text-left">
                  <p className="text-[#93979a] text-center">
                    {formatDate(event.event_date)}
                  </p>
                  {/* <p className="text-[#696b6a] text-center">10-02-2025</p> */}
                </div>
                {/* Details Section */}
                <div className="pl-4 mb-4 md:mb-0">
                  <div className="flex items-center mb-2">
                    <FaClock className="mr-2 text-[#93979a]" />
                    <span className="text-[#838383] font-bold text-sm">
                      {event.event_time}
                    </span>
                  </div>
                  <div className="flex items-center mb-2">
                    <FaHourglassStart className="mr-2 text-[#93979a]" />
                    <span className="text-[#838383] font-bold text-sm">
                      {event.duration} hours
                    </span>
                  </div>
                  <div className="flex items-center">
                    <FaMapMarkerAlt className="mr-2 text-[#93979a]" />
                    <span className="text-[#838383] font-bold text-sm">
                      {event.event_location}
                    </span>
                  </div>
                </div>
                {/* Event Section */}
                <div className="font-bold text-sm mb-4 md:mb-0 text-center md:text-left">
                  <div>
                    <p className="text-[#838383] mb-2">{event.event_topic}</p>
                  </div>
                  <div>
                    <p className="text-[#838383]">{event.event_name}</p>
                  </div>
                </div>
                {/* Zone Trainer Name and Membership ID Section */}
                <div className="font-bold text-sm mb-4 md:mb-0 text-center md:text-left">
                  <div>
                    <p className="text-[#93979a]">Zone Trainer Name:</p>
                    <p className="text-[#838383]">
                      {/* Loop through the selected_trainers array and join them with commas */}
                      {event.selected_trainers &&
                      event.selected_trainers.length > 0
                        ? event.selected_trainers.map((trainer, index) => (
                            <span key={index}>
                              {trainer}
                              {index < event.selected_trainers.length - 1 && (
                                <br />
                              )}
                            </span>
                          ))
                        : "No trainers selected"}
                    </p>
                  </div>
                </div>
                {/* Last Apply Date Section */}
                <div className="font-bold text-sm mb-4 md:mb-0 text-center md:text-left">
                  <div className="flex items-center justify-center md:justify-start mb-2">
                    <p className="text-[#ea3c3c]">Last Date to Apply</p>
                  </div>
                  <div className="flex items-center justify-center md:justify-start">
                    <MdDateRange className="mr-2 text-[#93979a]" />
                    <span className="text-[#838383] font-bold text-sm">
                      {formatDate(event.last_date)}
                    </span>
                  </div>

                  <div>
                    <p className="text-[#3f62de] mb-2">
                      Payment : ₹ {event.amount}
                    </p>
                  </div>
                </div>
                {/* Button Section */}
                <div className="text-right mt-10 flex flex-col md:flex-row md:justify-end">
                  <button
                    className="mb-2 md:mb-0 md:mr-2 bg-blue-600 text-white hover:bg-gray-800 p-2 rounded-lg w-full md:w-auto"
                    onClick={() => handlePaymentClick(event.event_id)}
                  >
                    Payment
                  </button>
                </div>
              </div>
            </div>
          ))
        : []}
      {showPopup && (
        <PaymentPopup
          onClose={handleClosePopup}
          onSubmit={handlePaymentSubmit}
          event_id={eventId}
        />
      )}
    </div>
  );
};

export default ConfirmetPage;
